



































































































































































































































































import Vue from 'vue';
import {
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import { VMoney } from 'v-money';
import RuleScript from '@/domain/scripts/entity/rule-script.entity';
import RuleScriptParameter from '@/domain/scripts/entity/rule-script-parameter.entity';
import MetaData from '@/domain/scripts/entity/metadata.entity';
import IconInfoDescription from '@/shared/icons/icon-info-description.component.vue';
import CurrencyConvertComponent from '@/shared/parameters/currency-convert-component.vue';
import KeyValueParameter from '@/shared/parameters/key-value-parameter.component.vue';
import RoleComponent from '@/shared/parameters/role-component.vue';
import Rules from '@/shared/rules/rules';
import BooleanTypes from './boolean-type.json';

@Component({
  components: {
    IconInfoDescription,
    CurrencyConvertComponent,
    KeyValueParameter,
    RoleComponent,
    VbTooltipSlot,
  },
  directives: {
    money: VMoney,
  },
})
export default class SimulateScriptParameters extends Vue {
  @Prop() ruleScript!: RuleScript;

  ruleToEdit: RuleScript = RuleScript.of({});

  readonly: boolean = false;

  ref: any = this.$refs;

  validationsRules: Rules = new Rules();

  arrayOfStripRanges: [] = [];

  rangeQuantity: number = 2

  metadataList: MetaData[] = [];

  stringValues: string = '';

  booleanType = BooleanTypes;

  created() {
    if (this.ruleScript) {
      this.ruleToEdit = RuleScript.of(this.ruleScript);
    }
  }

  valueText(type: string): string {
    if (type === 'RANGE' || type === 'RANGE2') {
      return 'Valor';
    }
    return 'Percentual'
  }

  getDirectiveByType(type: string) {
    if (type === 'RANGE') {
      return this.money;
    }
    if (type === 'RANGE2') {
      return this.money2;
    }
    if (type === 'RANGE_PERCENT2') {
      return this.percent2;
    }
    return this.percent;
  }

  getRulesByType(type: string) {
    if (type === 'MONEY2' || type === 'RANGE2' || type === 'RANGE_PERCENT2') {
      return this.validationsRules.money2EqualOrBiggerThanZero
    }
    return this.validationsRules.moneyEqualOrBiggerThanZero;
  }

  @Watch('ruleScript.parameters')
  applyParameters() {
    this.ruleScript.parameters.forEach((el: RuleScriptParameter) => {
      el.handleValueParameter();
    })
  }

  updateRuleScript() {
    this.$emit('updateRuleScript', this.ruleToEdit);
  }

  updateData() {
    this.$emit('updateData', this.metadataList)
  }

  addNewField() {
    this.metadataList.push(MetaData.of({}))
    this.updateData();
  }

  removeField(field: MetaData) {
    this.metadataList.splice(this.metadataList.indexOf(field), 1)
    this.updateData();
  }

  addString() {

  }

  money: object = {
    decimal: ',',
    thousands: '.',
    precision: 2,
    prefix: '$ ',
    masked: false,
    max: 9999.99,
    min: 0.01,
  };

  money2: object = {
    decimal: ',',
    thousands: '.',
    precision: 4,
    prefix: '$ ',
    masked: false,
    max: 9999.9999,
    min: 0.0001,
  };

  percent: object = {
    decimal: ',',
    thousands: '.',
    precision: 2,
    prefix: '% ',
    masked: false,
    max: 9999.99,
    min: 0.01,
  }

  percent2: object = {
    decimal: ',',
    thousands: '.',
    precision: 4,
    prefix: '% ',
    masked: false,
    max: 9999.9999,
    min: 0.0001,
  }
}
